
import * as constants from '../Constatnts'
import axios from 'axios'

export function saveBOM(bom, key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      let response = {};

      if (key !== "") {
        // Update existing account
        response = await axios.put(
          `${constants.API_URL}/catalog/bom/${key}`,
          bom,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        // Create new account
        response = await axios.post(
          `${constants.API_URL}/catalog/bom`,
          bom,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      if (response.data.code === "0") {
        if (key) {
          return key;
        } else {
          return response.data.data.key;
        }
      }

      return null;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function deleteBOMs(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.delete(
        `${constants.API_URL}/catalog/bom/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // API-level error handling
      if (response.data.code !== "0") {
        throw new Error(response.data.message || "Delete failed");
      }

      return response.data;

    } catch (error) {
      console.error("Error deleting bom:", error);
      throw error;
    }
  };
}
// export function deleteBOMs(key) {
//     return (dispatch, getState) => {
//         return database.collection("BOM").doc(key).update({
//             IsDeleted: true,
//             ActionOn: firebase.firestore.FieldValue.serverTimestamp(),
//             ActionBy: getState().user.user.Name,
//             ActionByUID: getState().user.user.UID,
//             ActionByEmailID: getState().user.user.EmailID,

//             Action: constants.AUDIT_TRAIL_DELETE
//         }).then(() => { return true })
//     }
// }
export function getBOMList(searchText, name, sku, status) {

  return async (dispatch, getState) => {

    try {

      const token = getState().user.uat;

      /* -------- PARAMS -------- */

      const params = {};

      if (searchText)
        params.searchText = searchText;

      if (name)
        params.name = name;

      if (sku)
        params.sku = sku;

      if (status)
        params.option = status;

     

      /* -------- API CALL -------- */

      const response = await axios.get(

        `${constants.API_URL}/catalog/bom`,

        {

          headers: {

            Authorization:
              `Bearer ${token}`

          },

          params: params

        }

      );


      /* -------- RESPONSE -------- */

      let boms = [];
      let totalCount = 0;


      if (

        response &&
        response.hasOwnProperty("data") &&
        response.data &&
        response.data.hasOwnProperty("code") &&
        response.data.code === "0"

      ) {

        if (

          response.data.hasOwnProperty("boms") &&
          Array.isArray(response.data.boms)

        ) {

          boms = response.data.boms;

          totalCount = response.data.boms.length;

        }

      }

      else {

        if (

          response &&
          response.hasOwnProperty("data") &&
          response.data &&
          response.data.hasOwnProperty("message")

        ) {

          alert(response.data.message);

        }

        else {

          alert("Failed to load data");

        }

      }


      return {

        searchResult: boms,

        totalCount: totalCount

      };

    }

    catch (error) {

      console.error(
        "Error fetching BOM list",
        error
      );

      return {

        searchResult: [],

        totalCount: 0

      };

    }

  };

}





export function getBOMDetails(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/catalog/bomdetail/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if(response.data.code=="0"){
return  response.data.bom;
      }
      else{
        alert(response.data.message || "failed to fetch bom");
        return {}
      }
      
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}